export default __webpack_public_path__ + "static/media/clap_icon.f4652d51.svg";